import { Button, Flex, Input, Typography } from 'antd';
import Styles from './styles';
import { DateSelector } from '../../../shared/components/DateSelector';
import { ReloadOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { sub } from 'date-fns';

const { Container, FilterWrapper } = Styles;

const { Search } = Input;

type Filters = {
  search?: string;
  from?: Date;
  to?: Date;
};

type Props = {
  onChange: (filters: Filters) => void;
};

export const ManualClipsFiltersBar: React.FC<Props> = ({ onChange }) => {
  const [inputValue, setInputValue] = useState('');
  const [search, setSearch] = useState('');
  const [dateOption, setDateOption] = useState('7d');
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    sub(new Date(), { days: 7 }),
    new Date(),
  ]);

  const searchDebounced = useDebouncedCallback((value: string) => {
    setSearch(value);
  }, 500);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    searchDebounced(value);
  };

  useEffect(() => {
    if (dateRange[0]) {
      dateRange[0].setHours(0);
    }

    if (dateRange[1]) {
      dateRange[1].setHours(23);
      dateRange[1].setMinutes(59);
      dateRange[1].setSeconds(59);
    }

    onChange({
      search,
      from: dateRange[0] ?? undefined,
      to: dateRange[1] ?? undefined,
    });
  }, [search, dateRange]);

  const handleResetFilters = () => {
    setSearch('');
    setInputValue('');
    setDateOption('7d');
  };

  return (
    <Container>
      <Flex justify="space-between" style={{ width: '100%' }}>
        <Flex gap={8}>
          <FilterWrapper>
            <Search
              placeholder="Search clips by title or meeting title"
              value={inputValue}
              onChange={handleInputChange}
            />
          </FilterWrapper>

          <DateSelector
            value={dateOption}
            defaultValues={[null, null]}
            direction="past"
            onDateOptionChanged={setDateOption}
            onDateRangeChanged={setDateRange}
            predefinedRanges={{
              '90d': false,
              '120d': false,
              '3m': false,
              '6m': false,
              '12m': false,
            }}
          />
        </Flex>

        <div>
          <Button icon={<ReloadOutlined />} onClick={handleResetFilters}>
            Reset Filters
          </Button>
        </div>
      </Flex>
    </Container>
  );
};
